import type { BlockId } from '@unifyapps/defs/types/block';
import { memo, useMemo } from 'react';
import type { BlockRendererComponentType } from '../../context/RegistryProvider/types';
import { getBlockPositionDataAttributes } from '../../utils/getBlockPositionDataAttributes';

function BlockRendererWrapper({
  blockId,
  index,
  parentBlockId,
  BlockRenderer,
}: {
  blockId: BlockId;
  index: number | string;
  parentBlockId: BlockId;
  BlockRenderer: BlockRendererComponentType;
}) {
  const dataAttributes = useMemo(() => getBlockPositionDataAttributes(index), [index]);

  return (
    <BlockRenderer
      blockId={blockId}
      dataAttributes={dataAttributes}
      parentBlockId={parentBlockId}
    />
  );
}

const MemoizedBlockRendererWrapper = memo(BlockRendererWrapper);

export default MemoizedBlockRendererWrapper;
